import { useFlagsQuery } from '../queries';

export const useFlags = () => {
  const { data, isLoading } = useFlagsQuery();

  if (isLoading) {
    return [];
  }

  return data ?? [];
};
